import { UIText1 } from '@cian/ui-kit';
import classNames from 'classnames';
import * as React from 'react';

import * as styles from './styles.css';

type TUserCardImages = {
  images: React.ReactNode;
};

export const UserCardImages: React.FC<TUserCardImages> = ({ images }) => {
  return (
    <div data-testid="UserCardImages" className={classNames(styles['container'])}>
      <div className={classNames(styles['header'])}>
        <UIText1>Фото</UIText1>
      </div>
      <div className={classNames(styles['content'])}>{images}</div>
    </div>
  );
};
